import { render, staticRenderFns } from "./NodeHeading.vue?vue&type=template&id=098b0cca"
import script from "./NodeHeading.vue?vue&type=script&lang=js"
export * from "./NodeHeading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports